import { RouteRecordRaw } from 'vue-router';
import { AuthRoutesEnum } from './AuthRoutesEnum';

const LoginPage         = () => import(/* webpackChunkName: "auth-module" */ '../pages/Login/LoginPage.vue');
const LostPasswordPage  = () => import(/* webpackChunkName: "auth-module" */ '../pages/LostPassword/LostPasswordPage.vue');
const ValidateUserPage  = () => import(/* webpackChunkName: "auth-module" */ '../pages/ValidateUser/ValidateUserPage.vue');
const ResetPasswordPage = () => import(/* webpackChunkName: "auth-module" */ '../pages/ResetPassword/ResetPasswordPage.vue');

const routes:  Array<RouteRecordRaw> = [
    {
        path: '/signin',
        alias: ['/login', '/sign-in'],
        name: AuthRoutesEnum.SIGN_IN,
        component: LoginPage,
        meta: {
            tabTitle: 'Login',
            requiresGuest: true
        }
    },
    {
        path: '/validate-user-email/:token',
        name: AuthRoutesEnum.VALIDATE_USER,
        props: true,
        component: ValidateUserPage,
        meta: {
            tabTitle: 'Validate user'
        }
    },
    {
        path: '/forgot-password',
        name: AuthRoutesEnum.FORGOTTEN_PWD,
        component: LostPasswordPage,
        meta: {
            tabTitle: 'Forgot password',
            requiresGuest: true
        }
    },
    {
        path: '/reset-password/:token',
        name: AuthRoutesEnum.RESET_PWD,
        component: ResetPasswordPage,
        props: true,
        meta: {
            tabTitle: 'Reset password',
            requiresGuest: true
        }
    }
];

export { routes };
export { AuthRoutesEnum };